/**
 * @module app.constants
 * Application-level timing and configuration constants.
 */

/** Duration in ms before an error toast auto-clears. */
export const ERROR_TIMEOUT_MS = 5000;

/** Duration in ms before a success message auto-clears. */
export const MESSAGE_TIMEOUT_MS = 3000;
